import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";

export default function LoginCheck({ children }) {
  const navigate = useNavigate();

  if (isAuthenticated()) {
    return <Navigate to={localStorage.getItem("userRole") === "employee" ? "/employee_landing_page" : localStorage.getItem("dashboard")} replace />;
  }

  return children;
}
export const isAuthenticated = () => {
  return !!localStorage.getItem("authToken");
};